export const FullPageRoutes = {
    path: '',
    component: () => import('@/layouts/FullPage.vue'),
    children: [
        // ================================= AUTH PAGES ================================
        {
            path: '/login',
            name: 'page-login',
            component: () => import('@/views/auth/LoginView.vue'),
            meta: {
                rule: 'editor'
            }
        },
        {
            path: '/register',
            name: 'page-register',
            component: () => import('@/views/auth/RegisterView.vue'),
            meta: {
                rule: 'editor'
            }
        },
        // ============================== HELPER PAGES =================================
        {
            path: '/comingsoon',
            name: 'page-coming-soon',
            component: () => import('@/views/error-pages/ComingSoon.vue'),
            meta: {
                rule: 'editor'
            }
        },
        {
            path: '/error-404',
            name: 'page-error-404',
            component: () => import('@/views/error-pages/Error404.vue'),
            meta: {
                rule: 'editor'
            }
        },
        {
            path: '/error-500',
            name: 'page-error-500',
            component: () => import('@/views/error-pages/Error500.vue'),
            meta: {
                rule: 'editor'
            }
        },
    ]
}